import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.333 15a.834.834 0 0 0 .834-.834v-5a.833.833 0 0 0-1.667 0v5a.833.833 0 0 0 .833.834m8.334-10h-3.334v-.833a2.5 2.5 0 0 0-2.5-2.5H9.167a2.5 2.5 0 0 0-2.5 2.5V5H3.333a.833.833 0 0 0 0 1.667h.834v9.166a2.5 2.5 0 0 0 2.5 2.5h6.666a2.5 2.5 0 0 0 2.5-2.5V6.667h.834a.833.833 0 0 0 0-1.667m-8.334-.833a.833.833 0 0 1 .834-.834h1.666a.833.833 0 0 1 .834.833V5H8.333zm5.834 11.666a.833.833 0 0 1-.834.833H6.667a.833.833 0 0 1-.834-.833V6.667h8.334zm-2.5-.833a.834.834 0 0 0 .833-.834v-5a.833.833 0 1 0-1.667 0v5a.833.833 0 0 0 .834.834"
    }, null, -1)
  ])))
}
export default { render: render }